import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useCancelarAtividadeAltExec = ({ data }) => {
  const {
    request: cancelarRequest,
    data: cancelarData,
    errors: cancelarErrors,
    isLoading: cancelarIsLoading,
  } = useApiClient();

  const cancelarAtividade = () => {
    const parametros = {
      sequencialAlteracaoExecutor: data?.sqAlteracaoExecutor,
      sequencialAndamento: data?.sequencialUltimoAndamento,
      sequencialAtividade: data?.sequencialAtividadeAndamento,
    };

    cancelarRequest(apiRoutes.fiscalizacao.alteracaoexecutor.cancelarAtividade, parametros);
  };

  useEffect(() => {
    if (cancelarIsLoading) return;

    if (!cancelarData && !cancelarErrors) return;

    if (cancelarData) {
      toast.success("Atividade cancelada com sucesso.");
      window.location.reload();
    }
  }, [cancelarData, cancelarErrors, cancelarIsLoading]);

  return { cancelarAtividade, cancelarErrors, cancelarIsLoading };
};

export default useCancelarAtividadeAltExec;
